import { isEmpty, fireAnalyticsEvent } from '@myap/ui-library'
import useStudentInfo from './useStudentInfo'
import { SCORE_SEND_FINAL_OPT_OUT_COMPLETE } from '../components/scoresend/constants'

const useAnalyticsStudentScoreSendOptOutEvent = ({ step }) => {
  const { appUser } = useStudentInfo()

  useEffect(() => {
    if (!isEmpty(appUser) && step !== 0) {
      fireAnalyticsEvent({
        testing: false,
        disabled: false,
        eventData: {
          appUser,
          appPage: {
            domain: 'student',
            page: 'declined',
            view: step === SCORE_SEND_FINAL_OPT_OUT_COMPLETE ? 'success' : `step-${step}`,
            group: 'free-score-send',
          },
        },
      })
    }
  }, [appUser, step])

  return null
}

export default useAnalyticsStudentScoreSendOptOutEvent
